<script lang="ts" setup>
import type { Inputable } from '../../../../lib/types/Inputable'
import type { Testable } from '../../../../lib/types/Testable'
import { FormControl, FormField, FormItem } from '../../form'
import { Label } from '../../label'
import { RadioGroup, RadioGroupItem } from '../../radio-group'

export interface RadioInputOption {
  label: string
  value: string
}

export interface RadioInputProperties extends Testable, Inputable {
  type?: 'radio'
  modelValue?: string
  items?: RadioInputOption[]
  label?: string
  disabled?: boolean
}
// Props
withDefaults(defineProps<RadioInputProperties>(), {
  id: '',
  type: 'radio',
  modelValue: '',
  class: undefined,
  name: undefined,
  required: false,
  label: undefined,
  items: () => [],
  disabled: false,
})
// end Props

// Emits
export interface ARadioInputEmits {
  (event: 'update:modelValue', data: string): void
}

const emit = defineEmits<ARadioInputEmits>()

// end Emits

// Refs
// end Refs

// Computed
// end Computed

// Functions
function onUpdateModelValue(value: string): void {
  emit('update:modelValue', value)
}
// end Functions

// Async Api functions
// end Async Api functions

// Lifecycle Hooks / Init
// end Lifecycle Hooks / Init
</script>

<template>
  <FormField v-slot="{ componentField }" :model-value="modelValue" :name="name || ''" @update:model-value="onUpdateModelValue">
    <FormItem>
      <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
      <Label v-if="label !== undefined">{{ label }} {{ required ? '*' : '' }}</Label>
      <FormControl>
        <RadioGroup v-for="(item, index) in items" :key="index" v-bind="componentField">
          <div class="atabix-radiogroup">
            <RadioGroupItem :id="item.value" :disabled="disabled" :value="item.value" />
            <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
            <Label v-if="item.value !== undefined" :for="item.value">{{ item.label }}</Label>
          </div>
        </RadioGroup>
      </FormControl>
    </FormItem>
  </FormField>
</template>

<style lang="scss">
/* stylelint-disable-next-line block-no-empty */
.atabix-radiogroup {
  @apply flex;
  @apply items-center;
  @apply space-x-2;
}
</style>
